import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MenuDTO } from '../../../../../system/system-dtos';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-entity-group-tabs',
  templateUrl: './entity-group-tabs.component.html',
  styleUrls: ['./entity-group-tabs.component.scss'],
  standalone: false,
})
export class EntityGroupTabsComponent implements OnChanges {
  @Input() menuConfig: MenuDTO;

  @Input() baseUrl: string;

  isOpen: boolean = false;

  tabGroups: TabGroup[];

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  navigate(url: string) {
    this.isOpen = !this.isOpen;
    this.router.navigate([url], { relativeTo: this.route.parent });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const tabs: TabGroup[] = [];
    this.menuConfig.entityGroup.menuItems.forEach((mi) => {
      const tabGroup = mi.tabGroup || '';
      if (tabs.length == 0 || tabs[tabs.length - 1].name !== tabGroup) {
        tabs.push({ name: mi.tabGroup, items: [mi] });
      } else {
        tabs[tabs.length - 1].items.push(mi);
      }
    });
    this.tabGroups = tabs;
  }
}

export interface TabGroup {
  name: string;
  items: MenuDTO[];
}
